<template>
    <CheckoutLayout
        :step="step"
    >
        <Heading
            :label="__('Payment')"
            :description="__('Select payment method')"
            class="w-auto lg:my-8 my-4"
            size="xl"
        />

        <div class="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-2">
            <div class="">
                <div
                    v-for="(p, key) in payments"
                    :key="key"
                    @click="selectedPayment = key"
                    class="border-2 rounded-md mb-3 p-3 flex items-center justify-between"
                >
                    <div>
                        <input type="radio" name="payment" :value="key" v-model="selectedPayment" class="form-radio h-5 w-5 text-blue-600">
                        <SvgIcon
                            class="inline ml-3 border-l border-r"
                            width="48"
                            height="48"
                            :name="p.icon"
                        />
                        <span class="ml-2 text-md font-semibold text-gray-700 ">{{p.name}}</span>
                    </div>
                    <div class="text-xl"></div>

                </div>
            </div>
            <div class="border-2 rounded-md mb-3 p-3 px-6 flex flex-col justify-between">

                <div>
                    <div
                        v-for="item in $page.props.cartitems"
                        :key="item"
                        class="flex justify-between border-b py-2"
                    >
                        <div class="font-bold">{{ item.product.name }}</div>
                        <div>{{ getTotalPerProduct(item) }}</div>
                    </div>
                </div>

                <div class="flex flex-row-reverse mt-8">
                    <div class="text-xl">{{ getTotalPrice }}</div>
                </div>
            </div>
        </div>

        <div
            class="flex justify-between mt-4"
        >
            <InertiaLink
                class="px-4 text-white font-semibold py-1 rounded-md transition ease-in-out duration-300 bg-gray-600 hover:bg-gray-700"
                :href="route('checkout.address')"
            >
                {{__('Back')}}
            </InertiaLink>
            <InertiaLink
                class="px-4 text-white font-semibold py-1 rounded-md transition ease-in-out duration-300 bg-green-600 hover:bg-green-700"
                :href="route('checkout.summary')"
                :disabled="selectedPayment == null"
                :class="selectedPayment != null ? '':'opacity-50 pointer-events-none select-none'"
            >
                {{__('Next')}}
            </InertiaLink>
        </div>
    </CheckoutLayout>
</template>

<script>
import CheckoutLayout from '@/Layouts/Checkout';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import CustomSelect from 'UI/CustomSelect';
import InputLabel from 'UI/InputLabel';
import Steps from 'STEPS/Container';
import StepItem from 'STEPS/Item';

import { ref } from '@vue/reactivity';
import Button from 'UI/Button';

import {
    getPrice,
    getPieces,
    getTotalPerProduct,
} from 'helper';
import { computed } from '@vue/runtime-core';

export default {
    components: {
        CheckoutLayout,
        SvgIcon,
        Heading,
        CustomSelect,
        InputLabel,
        Button,
        Steps,
        StepItem
    },
    props: {
        auth: Object,
        loggedin: Boolean,
        step: Number,
    },
    setup(props) {
        const selectedShipping = ref(localStorage.getItem('shipment') ? localStorage.getItem('shipment') : null);
        const selectedPayment = ref(localStorage.getItem('payment') ? localStorage.getItem('payment') : null);
        const payments = ref([
            {
                'name': 'Przelewy24',
                'slug': 'p24',
                'icon': 'cash'
            },
            {
                'name': 'PayU',
                'slug': 'payu',
                'icon': 'cash'
            }
        ]);
        // console.log(window.history)
        const user = props.loggedin ? props.auth.user : props.auth.guest;

        const getTotalPrice = computed(() => {
            let sum = 0;
            let items = usePage().props.value.cartitems;

            items.forEach(el => {
                sum += getTotalPerProduct(el, false);
            });

            if (selectedPayment) {
                localStorage.setItem('payment', selectedPayment.value);
            }

            return getPrice(sum);
        })



        return {
            user,
            selectedPayment,
            payments,
            selectedShipping,

            // computed
            getTotalPrice,

            getPrice,
            getPieces,
            getTotalPerProduct,
        }
    }
}
</script>
